import React from 'react';
import { Link } from 'react-router-dom';
import Icon from '../../../components/AppIcon';
import Button from '../../../components/ui/Button';

const ContactPrivacy = () => {
  return (
    <div className="bg-gradient-to-r from-primary to-secondary rounded-2xl p-8 lg:p-12 text-center">
      <div className="max-w-2xl mx-auto">
        <div className="inline-flex items-center justify-center w-16 h-16 bg-white/10 rounded-2xl mb-6">
          <Icon name="MessageCircle" size={32} className="text-white" />
        </div>
        
        <h2 className="text-2xl lg:text-3xl font-heading font-bold text-white mb-4">
          Questions About Your Privacy?
        </h2>
        
        <p className="text-lg text-white/90 mb-8">
          We're here to help. Our privacy team is ready to answer any questions about how we protect your family's information.
        </p>
        
        <div className="flex flex-col sm:flex-row items-center justify-center space-y-4 sm:space-y-0 sm:space-x-4">
          <Link to="/contact">
            <Button 
              variant="secondary" 
              className="bg-white text-primary hover:bg-white/90"
              iconName="Mail"
              iconPosition="left"
            >
              Contact Privacy Team
            </Button>
          </Link>
          
          <a 
            href="mailto:support@cynizee.com"
            className="flex items-center space-x-2 text-white/90 hover:text-white transition-colors duration-200"
          >
            <Icon name="Mail" size={16} />
            <span>support@cynizee.com</span>
          </a>
        </div>
      </div>
    </div>
  );
};

export default ContactPrivacy;